import React from 'react';
import AlertCard from './AlertCard';

interface ErrorBannerProps {
  message: string;
  onClose?: () => void;
}

export default function ErrorBanner({ message, onClose }: ErrorBannerProps) {
  return (
    <AlertCard
      isVisible={!!message}
      icon="⚠"
      title="Error"
      description={message}
      buttonText="Entendido"
      onButtonClick={onClose ?? (() => {})}
      onDismiss={onClose}
    />
  );
}
